<template>
  <svg width="747" height="884" viewBox="0 0 747 884" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle opacity="0.6" cx="441.5" cy="442.435" r="441" stroke="white"/>
    <circle opacity="0.6" cx="441.5" cy="442.434" r="319" transform="rotate(-83.1234 441.5 442.434)" stroke="white"/>
    <circle opacity="0.6" cx="441.5" cy="442.435" r="170.549" transform="rotate(112.898 441.5 442.435)" stroke="white"/>
    <circle opacity="0.6" cx="560.5" cy="677.435" r="5" fill="white" stroke="white"/>
    <circle opacity="0.6" cx="398.5" cy="353.435" r="5" fill="white" stroke="white"/>
    <circle opacity="0.6" cx="231.5" cy="429.435" r="8" fill="white" stroke="white"/>
    <circle opacity="0.6" cx="717.5" cy="405.435" r="5" fill="white" stroke="white"/>
  </svg>
</template>

<script>
export default {};
</script>
